import LabServiceModel from "@/models/LabServiceModel";

export default class AnalyteResultModel extends LabServiceModel {

  modelName() {
    return 'analyte-result';
  }

  publicRoutes() {
    let routes = super.publicRoutes() || {};
    routes.fetch = process.env.VUE_APP_LAB_REPOSITORY_URL + '/api/v1/public/' + this.modelName() + '/{id}';
    return routes;
  }

  defaults() {
    return {
      analysis: null,
      analysis_id: null,
      analyte: null,
      analyte_id: null,
      analyte_result_status_logs: [],
      batch_index: 0,
      created_at: null,
      created_by: null,
      current_analyte_result_status_log: null,
      deleted_at: null,
      formatted_result: null,
      id: null,
      instrument_instance: null,
      instrument_instance_id: null,
      instrument_jig: null,
      instrument_jig_id: null,
      jig_index: 0,
      raw_result: null,
      sample: null,
      sample_id: null,
      schedulable_task: null,
      schedulable_task_id: null,
      schedulable_task_type: null,
      unit_of_measure: null,
      unit_of_measure_id: null,
      updated_by: null,
      updated_at: null
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      analysis_id: val => this.nullStringMutator(val),
      analyte_id: val => this.nullStringMutator(val),
      batch_index: val => this.nullStringMutator(val),
      created_at: val => this.nullStringMutator(val),
      deleted_at: val => this.nullStringMutator(val),
      formatted_result: val => this.nullStringMutator(val),
      id: val => this.nullStringMutator(val),
      instrument_instance_id: val => this.nullStringMutator(val),
      instrument_jig_id: val => this.nullStringMutator(val),
      jig_index: val => this.nullStringMutator(val),
      raw_result: val => this.nullStringMutator(val),
      sample_id: val => this.nullStringMutator(val),
      schedulable_task_id: val => this.nullStringMutator(val),
      schedulable_task_type: val => this.nullStringMutator(val),
      unit_of_measure_id: val => this.nullStringMutator(val),
      updated_at: val => this.nullStringMutator(val)
    }
  }

}
